import {
  DejavooDiagnosticRequest,
  DejavooDiagnosticResponse,
} from '@chiroup/core/types/Devtools.type';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import devtoolsService from '../services/devtools.service';

const QUERY_KEY = ['dejavoo-diagnostics'] as const;

export const useDejavooDiagnostics = (enabled = true) =>
  useQuery<DejavooDiagnosticResponse>(
    QUERY_KEY,
    () => devtoolsService.dejavooDiagnostics.request({ fn: 'get' }),
    { enabled, refetchOnWindowFocus: false }
  );

const useDiagnosticMutation = <TRequest extends DejavooDiagnosticRequest>() => {
  const queryClient = useQueryClient();

  return useMutation<DejavooDiagnosticResponse, unknown, TRequest>(
    request => devtoolsService.dejavooDiagnostics.request(request),
    {
      onSuccess: response => {
        queryClient.setQueryData(QUERY_KEY, response);
      },
    }
  );
};

export const useStartDejavooDiagnostics = () =>
  useDiagnosticMutation<Extract<DejavooDiagnosticRequest, { fn: 'start' }>>();

export const useProcessDejavooDiagnostics = () =>
  useDiagnosticMutation<Extract<DejavooDiagnosticRequest, { fn: 'process' }>>();

export const useDeepDejavooDiagnosis = () =>
  useDiagnosticMutation<Extract<DejavooDiagnosticRequest, { fn: 'deepDiagnose' }>>();

export const useDejavooDiagnosticAutofix = () =>
  useDiagnosticMutation<Extract<DejavooDiagnosticRequest, { fn: 'autofix' }>>();
